import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Error404 = () => {
  return (
    <Container fluid className='min-vh-100'>
      <Row className='h-100 justify-content-center align-items-center'>
        <Col xs={10} sm={8} md={6} lg={4} className='text-center'>
          <h1 style={{ fontSize: '6rem', fontWeight: '700', color: '#dc3545' }}>
            404
          </h1>

          <h2 className='mb-3' style={{ fontWeight: '600' }}>
            Page Not Found
          </h2>

          <p className='mb-4' style={{ fontSize: '1.1rem', color: '#6c757d' }}>
            The page you’re looking for doesn’t exist or has been moved.
          </p>

          <Button href='/' variant='primary' size='lg'>
            Go Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Error404;
